import { render, staticRenderFns } from "./TopProvincesMapChart.vue?vue&type=template&id=242e006a"
import script from "./TopProvincesMapChart.vue?vue&type=script&lang=js"
export * from "./TopProvincesMapChart.vue?vue&type=script&lang=js"
import style0 from "./TopProvincesMapChart.vue?vue&type=style&index=0&id=242e006a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports